import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error(
    "VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY sao obrigatorias. " +
      "Elas sao embutidas no bundle em build-time: mudou, precisa rebuild.",
  );
}

/**
 * Client publico do Supabase. So a camada `features/<f>/api/` deve importar isto:
 * componente e hook nao falam com o Supabase direto. Ver CLAUDE.md.
 *
 * O app mora na raiz do dominio, entao a sessao usa cookie com prefixo `__Host-`
 * para nao vazar para studio.samev.com.br. Ajustado na fase 1, junto com o Auth.
 */
export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
